/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const configs = {
	NODE_TYPE_IF_THEN: 'CLASSIC_LIST_BRANCH',
	NODE_TYPE_IF_THEN_PARALLEL: 'PARALLEL_LIST_BRANCH',
	NODE_TYPE_SPLIT: 'AB_SPLIT',
	NODE_TYPE_SPLIT_NODE: 'AB_SPLIT_NODE',
	NODE_TYPE_SPLIT_NODE_CONTROL: 'AB_SPLIT_CONTROL_NODE',
	NODE_TYPE_CONDITION_YES: 'CONDITION_YES',
	NODE_TYPE_CONDITION_NO: 'CONDITION_NO',
	NODE_TYPE_SCHEDULED: 2,
	NODE_TYPE_ACTION_BASE: 3,
	NODE_TYPE_DELAY: 4,
	NODE_TYPE_HTTP_API: 5,
	NODE_TYPE_MESSENGER: 6,
	NODE_TYPE_MEPUZZ: 7,
	NODE_TYPE_AMAZON_SES: 8,
	NODE_TYPE_ERP_API_BIBOMARTP: 9,
	NODE_TYPE_PERSONALIZATION: 10,
	NODE_TYPE_GO_TO_OTHER_ACTION: 'GO_TO',
	NODE_TYPE_WFR: 'WAIT_FOR_RESPONSE',
	NODE_TYPE_WFR_NODE: 'WAIT_FOR_RESPONSE_NODE',
	NODE_TYPE_WFR_NODE_NO: 'WAIT_FOR_RESPONSE_NODE_NO',
	REMOVE_NODE: 'REMOVE_NODE',
	// NODE_TYPE_IF_THEN_PARENT_NODE: 12,
	// REMOVE_NODE: 'REMOVE_NODE',
	DEFAULT_LINE_HEIGHT: 100,

	WAIT_EVENT: 'WAIT_EVENT',
	WAIT_EVENT_HAPPENED: 'WAIT_EVENT_HAPPENED',
	WAIT_EVENT_TIMEOUT: 'WAIT_EVENT_TIMEOUT',

	ALLOCATE_COUPON: 'ALLOCATE_COUPON',
	ALLOCATE_COUPON_SUCCESS: 'ALLOCATE_COUPON_SUCCESS',
	ALLOCATE_COUPON_NOT_ENOUGH: 'ALLOCATE_COUPON_NOT_ENOUGH',
	ALLOCATE_COUPON_NOT_MATCH: 'ALLOCATE_COUPON_NOT_MATCH'
};

export const MODE = {
	VIEW: 'view',
	EDIT: 'edit'
};

export const NODE_TYPE = {
	EVENT_BASED: 'EVENT_BASED',
	SCHEDULED: 'SCHEDULED',
	DELAY: 'DELAY',
	CLASSIC_LIST_BRANCH: 'CLASSIC_LIST_BRANCH',
	PARALLEL_LIST_BRANCH: 'PARALLEL_LIST_BRANCH',
	FILTER: 'FILTER',
	GO_TO: 'GO_TO',
	DESTINATION: 'DESTINATION',
	END: 'END',
	CONDITION_YES: 'CONDITION_YES',
	CONDITION_NO: 'CONDITION_NO',
	AB_SPLIT: 'AB_SPLIT',
	AB_SPLIT_NODE: 'AB_SPLIT_NODE',
	WAIT_EVENT: 'WAIT_EVENT',
	WAIT_EVENT_HAPPENED: 'WAIT_EVENT_HAPPENED',
	WAIT_EVENT_TIMEOUT: 'WAIT_EVENT_TIMEOUT',
	UPDATE_INFO: 'UPDATE_INFO',
	UPDATE_SEGMENT: 'UPDATE_SEGMENT',
	AB_SPLIT_CONTROL_NODE: 'AB_SPLIT_CONTROL_NODE',
	WFR_BRANCH: 'WAIT_FOR_RESPONSE',
	WFR_NODE: 'WAIT_FOR_RESPONSE_NODE',
	WFR_NODE_NO: 'WAIT_FOR_RESPONSE_NODE_NO',
	ALLOCATE_COUPON: 'ALLOCATE_COUPON',
	ALLOCATE_COUPON_SUCCESS: 'ALLOCATE_COUPON_SUCCESS',
	ALLOCATE_COUPON_NOT_ENOUGH: 'ALLOCATE_COUPON_NOT_ENOUGH',
	ALLOCATE_COUPON_NOT_MATCH: 'ALLOCATE_COUPON_NOT_MATCH'
};

export const TRIGGER_NODE = [NODE_TYPE.EVENT_BASED, NODE_TYPE.SCHEDULED];

export const NODE_ICON = {
	[NODE_TYPE.EVENT_BASED]: 'icon-antsomi-touch',
	[NODE_TYPE.SCHEDULED]: 'icon-antsomi-alarm',
	[NODE_TYPE.DELAY]: 'icon-antsomi-more-time',
	[NODE_TYPE.CLASSIC_LIST_BRANCH]: 'icon-antsomi-classic-branch',
	[NODE_TYPE.PARALLEL_LIST_BRANCH]: 'icon-antsomi-parallel-filter',
	[NODE_TYPE.FILTER]: 'icon-antsomi-filter-list',
	[NODE_TYPE.GO_TO]: '',
	[NODE_TYPE.DESTINATION]: '',
	[NODE_TYPE.END]: 'icon-antsomi-flag',
	[NODE_TYPE.CONDITION_YES]: 'icon-antsomi-check',
	[NODE_TYPE.CONDITION_NO]: 'icon-antsomi-close',
	[NODE_TYPE.AB_SPLIT]: 'icon-antsomi-call-split',
	[NODE_TYPE.AB_SPLIT_NODE]: 'icon-antsomi-arrow-forward',
	[NODE_TYPE.WAIT_EVENT]: 'icon-antsomi-hourglass-top',
	[NODE_TYPE.WAIT_EVENT_HAPPENED]: 'icon-antsomi-check',
	[NODE_TYPE.WAIT_EVENT_TIMEOUT]: 'icon-antsomi-close',
	[NODE_TYPE.UPDATE_INFO]: 'icon-antsomi-edit-note',
	[NODE_TYPE.UPDATE_SEGMENT]: 'icon-antsomi-update-segment',
	[NODE_TYPE.AB_SPLIT_CONTROL_NODE]: 'icon-antsomi-arrow-forward',
	[NODE_TYPE.WFR_BRANCH]: 'icon-antsomi-response-routing',
	[NODE_TYPE.ALLOCATE_COUPON_SUCCESS]: 'icon-antsomi-check',
	[NODE_TYPE.ALLOCATE_COUPON_NOT_ENOUGH]: 'icon-antsomi-close',
	[NODE_TYPE.ALLOCATE_COUPON_NOT_MATCH]: 'icon-antsomi-close'
};

export const RULES = {
	init: {
		after: [
			'CLASSIC_LIST_BRANCH',
			'PARALLEL_LIST_BRANCH',
			'AB_SPLIT',
			'DELAY',
			'FILTER',
			'GO_TO',
			'DESTINATION',
			'AB_SPLIT_NODE',
			'WAIT_EVENT',
			'UPDATE_INFO',
			'UPDATE_SEGMENT',
			'WAIT_FOR_RESPONSE',
			'WAIT_FOR_RESPONSE'
		]
	},
	EVENT_BASED: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	SCHEDULED: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	DELAY: {
		before: ['EVENT_BASED', 'SCHEDULED', 'DELAY', 'DESTINATION'],
		after: ['EVENT_BASED', 'SCHEDULED', 'FILTER', 'DELAY', 'WAIT_FOR_RESPONSE']
	},
	FILTER: {
		before: ['EVENT_BASED', 'SCHEDULED', 'DELAY', 'FILTER', 'DESTINATION'],
		after: ['EVENT_BASED', 'SCHEDULED', 'FILTER', 'WAIT_FOR_RESPONSE']
	},
	GO_TO: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	DESTINATION: {
		before: ['EVENT_BASED', 'SCHEDULED', 'GO_TO', 'DESTINATION'],
		after: [
			'EVENT_BASED',
			'SCHEDULED',
			'DELAY',
			'FILTER',
			'GO_TO',
			'DESTINATION',
			'CLASSIC_LIST_BRANCH',
			'PARALLEL_LIST_BRANCH',
			'AB_SPLIT',
			'WAIT_EVENT',
			'UPDATE_INFO',
			'UPDATE_SEGMENT',
			{
				key: Symbol('allow_wfr_after'),
				handler: ({node, actingNode}) => {
					const isValidCatalog = ['g_suite_email'].some((c) => c === node?.catalogCode);

					// if (node?.nodeId === '1bi37') {
					// 	console.log('limit_dest_by_catalog', node);
					// }

					// A violation occurs only when:
					// 1. The acting node is in the 'WAIT_FOR_RESPONSE'
					// 2. The node's catalogCode is NOT in the list of valid catalogs
					return actingNode?.type === 'WAIT_FOR_RESPONSE' ? !isValidCatalog : false;
				}
			}
		]
	},
	CONDITION_YES: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	CONDITION_NO: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	[NODE_TYPE.WFR_BRANCH]: {
		before: [
			'EVENT_BASED',
			'SCHEDULED',
			{
				key: Symbol('limit_dest_by_catalog'),
				handler: ({node, actingNode}) => {
					const isValidCatalog = ['g_suite_email'].some((c) => c === actingNode?.catalogCode);

					// if (node?.nodeId === '1bi37') {
					// 	console.log('limit_dest_by_catalog', node);
					// }

					// A violation occurs only when:
					// 1. The acting node is in the 'DESTINATION'
					// 2. The destination node's catalogCode is NOT in the list of valid catalogs
					return actingNode?.type === 'DESTINATION' ? !isValidCatalog : false;
				}
			}
		],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	[NODE_TYPE.WFR_NODE]: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	[NODE_TYPE.WFR_NODE_NO]: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	AB_SPLIT_NODE: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_FOR_RESPONSE']
	},
	WAIT_EVENT: {
		before: [
			'EVENT_BASED',
			'SCHEDULED',
			'WAIT_EVENT',
			'DESTINATION',
			'UPDATE_INFO',
			'UPDATE_SEGMENT',
			'WAIT_FOR_RESPONSE'
		],
		after: ['EVENT_BASED', 'SCHEDULED']
	},
	WAIT_EVENT_HAPPENED: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_EVENT', 'WAIT_FOR_RESPONSE']
	},
	WAIT_EVENT_TIMEOUT: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: ['EVENT_BASED', 'SCHEDULED', 'WAIT_EVENT', 'WAIT_FOR_RESPONSE']
	},
	UPDATE_INFO: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: [
			'EVENT_BASED',
			'SCHEDULED',
			'DELAY',
			'FILTER',
			'GO_TO',
			'DESTINATION',
			'CLASSIC_LIST_BRANCH',
			'PARALLEL_LIST_BRANCH',
			'AB_SPLIT',
			'WAIT_EVENT',
			'UPDATE_INFO',
			'UPDATE_SEGMENT',
			'WAIT_FOR_RESPONSE'
		]
	},
	UPDATE_SEGMENT: {
		before: ['EVENT_BASED', 'SCHEDULED'],
		after: [
			'EVENT_BASED',
			'SCHEDULED',
			'DELAY',
			'FILTER',
			'GO_TO',
			'DESTINATION',
			'CLASSIC_LIST_BRANCH',
			'PARALLEL_LIST_BRANCH',
			'AB_SPLIT',
			'WAIT_EVENT',
			'UPDATE_SEGMENT',
			'WAIT_FOR_RESPONSE'
		]
	}
};

export const NODE_STATE = {
	DEFAULT: 'DEFAULT',
	HOVER: 'HOVER',
	ACTIVE: 'ACTIVE'
};

export const STYLES = {
	backgroundColor: 'backgroundColor',
	borderColor: 'borderColor',
	color: 'color'
};

export const NODE_COLOR_TYPE = {
	...NODE_TYPE,
	NORMAL: 'NORMAL',
	ERROR: 'ERROR'
};

export const NODE_COLOR = {
	[NODE_COLOR_TYPE.NORMAL]: {
		DEFAULT: {color: '#595959', backgroundColor: '#cae5fe', borderColor: 'none'},
		HOVER: {color: '#005eb8', backgroundColor: '#cae5fe', borderColor: '#81bcf4'},
		ACTIVE: {color: '#005eb8', backgroundColor: '#ffffff', borderColor: '#005eb8'}
	},
	[NODE_COLOR_TYPE.ERROR]: {
		DEFAULT: {color: '#595959', backgroundColor: '#ffb8be', borderColor: 'none'},
		HOVER: {color: '#ef3340', backgroundColor: '#ffb8be', borderColor: '#ff989f'},
		ACTIVE: {color: '#ef3340', backgroundColor: '#ffffff', borderColor: '#ef3340'}
	},
	[NODE_COLOR_TYPE.END]: {
		DEFAULT: {color: '#bebebe', backgroundColor: '#f0f0f0', borderColor: 'none'},
		HOVER: {color: '#a2a2a2', backgroundColor: '#f0f0f0', borderColor: 'none'}
	},
	[NODE_COLOR_TYPE.SCHEDULED]: {
		DEFAULT: {color: '#595959', backgroundColor: '#ffdd9f', borderColor: 'none'},
		HOVER: {color: '#f29100', backgroundColor: '#ffdd9f', borderColor: '#ffbb4e'},
		ACTIVE: {color: '#f29100', backgroundColor: '#ffffff', borderColor: '#f29100'}
	},
	[NODE_COLOR_TYPE.EVENT_BASED]: {
		DEFAULT: {color: '#595959', backgroundColor: '#c2f3eb', borderColor: 'none'},
		HOVER: {color: '#0cac91', backgroundColor: '#c2f3eb', borderColor: '#0cac91'},
		ACTIVE: {color: '#0cac91', backgroundColor: '#ffffff', borderColor: '#0cac91'}
	},
	[NODE_COLOR_TYPE.DESTINATION]: {
		DEFAULT: {color: '#595959', backgroundColor: '#ffffff', borderColor: '#e5e5e5'},
		HOVER: {color: '#595959', backgroundColor: '#ffffff', borderColor: '#81bcf4'},
		ACTIVE: {color: '#005eb8', backgroundColor: '#ffffff', borderColor: '#005eb8'}
	}
};
